import { SearchX } from 'lucide-react'
import { ScreenTitle, StateIcon } from './EntryPanel'

/**
 * "This booking page doesn't exist" (Frontend §3.5 `not_found`, §4.1): an unknown or malformed slug. No screen ID.
 * `panel`: the same message inside the embed's entry panel (T-P00-07).
 */
export function BookingPageNotFound({ variant = 'page' }: { variant?: 'page' | 'panel' }) {
  if (variant === 'panel') {
    return (
      <>
        <StateIcon tone="warn">
          <SearchX />
        </StateIcon>
        <ScreenTitle>This booking page doesn&apos;t exist</ScreenTitle>
      </>
    )
  }
  return (
    <div className="site-message">
      <div className="card card-pad">
        <span className="state-icon tone-warn" aria-hidden>
          <SearchX />
        </span>
        <ScreenTitle className="serif">This booking page doesn&apos;t exist</ScreenTitle>
      </div>
    </div>
  )
}
